export default class SourceController{
   constructor(){
      this.tabClicked = ::this.tabClicked;
      this.components = Array.from( document.querySelectorAll('.source') );
      this.components.forEach( component => {
         this.init(component);
      });
   }

   init(component){
      const source = component;
      const links = Array.from(source.querySelectorAll('.js-source-navigation-link'));

      links.forEach( link => {
         link.addEventListener('click', this.tabClicked);
      });
   }


   setActiveTab(tab){
      const id = tab.parentNode.getAttribute('data-id');
      const links = Array.from(tab.parentNode.parentNode.children);
      const contents = Array.from(tab.parentNode.parentNode.parentNode.parentNode.querySelectorAll('.js-source-content-item'));

      contents.forEach( (content,index) => {
         const link = links[index];
         const linkId = link.getAttribute('data-id');
         const contentId = content.getAttribute('data-id');

         if(contentId === id){
            content.classList.add('is-active');
         }else{
            content.classList.remove('is-active');
         }

         if(linkId === id){
            const button = link.querySelector('button');
            button.setAttribute('disabled', true);
            link.classList.add('is-active');
         }else{
            const button = link.querySelector('button');
            button.removeAttribute('disabled');
            link.classList.remove('is-active');
         }
      });
   }

   tabClicked(e){
      e.preventDefault();
      const tab = e.currentTarget;
      if(tab.parentNode.classList.contains('is-active')) return;
      this.setActiveTab(tab);
   }
}


// WEBPACK FOOTER //
// ./Components/SourceController.js